import styled from 'styled-components';
import { LEFT_ALIGNED } from '../visitor-widget/constants/WidgetLocations';
export const WelcomePageWrapper = styled.div.withConfig({
  displayName: "WelcomePageLayoutComponents__WelcomePageWrapper",
  componentId: "adp74e-0"
})(["position:relative;display:flex;flex-direction:column;width:", ";align-items:", ";"], ({
  $width
}) => `${$width}px`, ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');
export const WelcomePageContent = styled.div.withConfig({
  displayName: "WelcomePageLayoutComponents__WelcomePageContent",
  componentId: "adp74e-1"
})(["margin-top:25px;display:flex;flex-direction:column;gap:10px;width:", ";"], ({
  $width
}) => `${$width}px`);
export const HeightCalcWrapper = styled.div.withConfig({
  displayName: "WelcomePageLayoutComponents__HeightCalcWrapper",
  componentId: "adp74e-2"
})(["display:flex;flex-direction:column;gap:10px;align-items:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');